import CustomUpdatedPopUpModal from '../../mobilecomponents/eir-porting/CustomModal/CustomUpdatedPopUpModal';
import { Box, Typography, Button } from '@material-ui/core';
import useStyle from './style.js';
import { useState } from 'react';
import React from 'react';
import EirButton from '../../theme/EirButton';

const LatestAppInfoPopup = props => {
    const [openPopup, setOpenPopup] = useState(props.open);
    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });
    const styles = useStyle();

    const handleCTA = async () => {
        const appId = '6482999932';
        const iOSLink = `itms-apps://itunes.apple.com/app/id${appId}`;
        const fallbackLink = `https://apps.apple.com/app/id${appId}`;

        //Detect iOS

        if (window?.iOSAppInfo !== null) {
            //iOS
            window.location.href = iOSLink;

            setTimeout(() => {
                window.location.href = fallbackLink;
            }, 400);
        } else {
            window.location.assign(fallbackLink);
        }

        setOpenPopup(false);
        props.setOpen(false);
    };

    return (
        <Box className='infoHandle' maxWidth='md'>
            <CustomUpdatedPopUpModal
                cssId='myeir-modal-window-info'
                open={openPopup}
                cta1={cta1}
                cta2={cta2}
                toggle={handleCTA}
                flag='info'
            >
                <Typography className={styles.headText}>Update required</Typography>

                <Box style={{ textAlign: 'center' }}>
                    <Typography className={styles.infoText}>
                        We have done an update to our app, to continue using it please update to the
                        latest version.
                    </Typography>
                    <EirButton
                        variants='primaryButtonMedium'
                        style={{ padding: '0.5rem 2rem' }}
                        onClick={handleCTA}
                    >
                        Update now
                    </EirButton>
                </Box>
            </CustomUpdatedPopUpModal>
        </Box>
    );
};

export default LatestAppInfoPopup;
